import makeStyles from '@mui/styles/makeStyles';

const text_default_color = "#465869";
const text_second_color = "#308CDB";
const background_second_color = "rgba(48, 140, 219, 0.1)";

const styles = makeStyles((theme) => ({
  title: {
    font: "500 16px/24px Inter",
    color: `${text_default_color}`,
    marginBottom: 20,
  },
  shareTypeList: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    listStyle: "none",
    paddingRight: 0,
    "& li": {
      padding: "7px 13px",
      color: `${text_second_color}`,
      cursor: "pointer",
      font: "700  Manrope",
      "&.active": {
        borderRadius: 8,
        backgroundColor: `${background_second_color}`,
      },
    },
  },
  buttonShare: {
    width: 92,
    border: "1px solid #E6E9F1",
    color: `${text_default_color} !important`,
    "& div[role=progressbar]": {
      color: `${text_default_color}`,
    },
  },
}));

export default styles;
